import { structurePoints } from "@/mocks/home";

export default function Structure() {
  return (
    <section id="structure" className="bg-background-50 border-t border-background-200">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-medium tracking-wide text-accent-700">
            内容结构
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950 leading-snug">
            从开场到片尾：一段完整的内容是怎么走的
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            无论片长如何，叙事通常会沿一条相对稳定的线索推进。了解这四个阶段，
            有助于你判断被删减的版本究竟少了哪一部分。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {structurePoints.map((step) => (
            <article
              key={step.id}
              className="relative rounded-lg bg-background-100 border border-background-200 p-5 md:p-6"
            >
              <div className="flex items-center gap-3">
                <span className="font-heading text-2xl font-semibold text-accent-500">
                  {step.no}
                </span>
                <span className="h-px flex-1 bg-background-300"></span>
              </div>
              <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}